import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LIBRARY_ROOT_DIRECTORY_ID } from '../services/library-folders-service';

export const useLibraryCurrentFolder = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const folderId = searchParams.get('folder') || LIBRARY_ROOT_DIRECTORY_ID;
  const isRoot = folderId === LIBRARY_ROOT_DIRECTORY_ID;

  const openFolder = useCallback(
    (id: string) => {
      setSearchParams((params) => {
        const next = new URLSearchParams(params);
        if (!id || id === LIBRARY_ROOT_DIRECTORY_ID) {
          next.delete('folder');
        } else {
          next.set('folder', id);
        }
        return next;
      });
    },
    [setSearchParams]
  );

  return { folderId, isRoot, openFolder };
};
